import { render, staticRenderFns } from "./psychology.vue?vue&type=template&id=2caf526d&scoped=true"
import script from "./psychology.vue?vue&type=script&lang=js"
export * from "./psychology.vue?vue&type=script&lang=js"
import style0 from "./psychology.vue?vue&type=style&index=0&id=2caf526d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf526d",
  null
  
)

export default component.exports